// import React from 'react';
import { graphql } from 'gatsby';
import SEO from '@components/Common/SEO/index';
import '@fortawesome/fontawesome-svg-core/styles.css';
import React, { useContext, useEffect } from 'react';
import Navigation from '@components/NavigationV2/index';
import FooterV2 from '@components/FooterV2/index';
import CrackedCrioCareersSection from '@components/v5/CrackedCrioCareersSection/index';
import VideoTestimonialSection from '@components/v5/VideoTestimonialSection/index';
import CrioComparisonSectionV2 from '@components/v5/CrioComparisonSectionV2/index';
import FAQSection from '@components/v5/FAQSection/index';
import ProgramHighlights from '@components/v5/ProgramHighlights/index';
import ChooseSpecialization from '@components/v5/ChooseSpecialization/index';
import CrioButton from '@components/v5/CrioButton/index';
import PostContentCTALayout from '@components/v5/layouts/PostContentCTALayout/index';
import { Link } from 'gatsby';
import { ERoutes } from '@src/constants/routes/index';
import { EProgramIDs } from '@src/constants/data/programs/index';
import SaleMiddleStrip from '@components/v5/Sale/SaleMiddleStrip';
import { stripData } from '@components/Sale/data';
import FspStylePageHero from '@components/v5/FspStylePageHero/index';
import FspPricingCardSection from '@components/v5/FspPricingCardSection/index';
import LeadGenerationButton from '@components/LeadGenerationForm/LeadGenerationButton';
import {
  LEAD_GEN_HOME_PROJECTS,
  LEAD_GEN_FLOATING_CTA,
  LEAD_GEN_DEVELOPERS_CRACKED,
  LEAD_GEN_WHY_CRIO,
  LEAD_GEN_PROJECTS,
  LEAD_GEN_TESTIMONIALS,
  LEAD_GEN_CRIO_COMPARISION,
  LEAD_GEN_CURRICULUM_PRICING_CARD,
  // LEAD_GEN_PLAN_SECTION,
} from '../constants/LeadGenerationConstants/index';
import ScrollButtonComponent from '@components/ScrollButtonComponent/index';
import { useWebEngage } from '@src/hooks/useWebEngage';
import { GlobalStateContext } from '@src/context/GlobalContextProvider';
import { ELeadSquaredActivityCode } from '@src/constants/leadsquaredActivityConstants/index';
import { GTM } from '@src/analytics/gtm';
// import PersonalizedPlan from '@components/v5/PersonalizedPlan/index';
import TechnologiesMasterSection from '@components/v5/TechnologiesMasterSection/index';
import fsp from '../seo/jsonld/fsd.json';
import fdt from '../seo/jsonld/fdt.json';
import bdt from '../seo/jsonld/bdt.json';
import dataScienceJsonLd from '../seo/jsonld/data-science.json';
import { gtmEvents } from '@src/analytics/gtmEventsConstant';
import useCrioStat from '@src/hooks/useCrioStats';
// import FspCurriculumSectionV3 from '@components/v5/FspCurriculumSection-V3/index';
import WhyCrioSectionV3 from '@components/v5/WhyCrioSectionV3/index';
import useDataScienceProgram from '@src/hooks/useDataScienceProgram';
import CurriculumV5 from '@components/v5/CurriculumV5';
import { curriculumData } from '@src/constants/fsdCurriculumDataV2';
import BottomStrip from '@components/PPCNavbar/BottomStrip';
import MentorTestimonialsSection from '@components/MentorSection';
import useSendActivities from '@src/hooks/useSendActivities';
import ProjectsV2 from '@components/v5/ProjectsV2';
import SkillSectionV2 from '@components/v5/SkillSectionV2';

export default function FspStylePage(props) {
  const { captureUserClickEvent } = useWebEngage();
  const state = useContext(GlobalStateContext);

  const { isDataSciencePage } = useDataScienceProgram();
  const { sendActivityHandler } = useSendActivities();

  const onPlacementButtonClick = () => {
    captureUserClickEvent('Get our Placement Stats', {
      placementLocation: 'FSP_PAGE',
    });

    sendActivityHandler(
      ELeadSquaredActivityCode.SD_PAGE_GET_OUR_PLACEMENT_STATS_CLICKED,
    );
  };
  const { data: queryData } = props;

  const { fspStylePagesYaml: data } = queryData;
  const program = props.data.allStrapiPrograms.nodes.find(
    (ele) => ele.PrimaryProgramID == data.PrimaryProgramID,
  );

  const programId = program?.PrimaryProgramID;
  const jsonLd =
    programId === EProgramIDs.DATA_SCIENCE
      ? dataScienceJsonLd
      : programId === EProgramIDs.FULL_STACK
      ? fdt
      : programId === EProgramIDs.FELLOWSHIP
      ? fsp
      : bdt;

  const sale = props.data.strapiSale.SaleID;

  const { placementStats } = useCrioStat();

  const getProjectsSectionPreContent = (sale) => {
    switch (sale) {
      case 'true':
        return (
          <div className="mx-4 mb-10 flex justify-center">
            <SaleMiddleStrip data={stripData[program.PrimaryProgramID]}>
              <LeadGenerationButton
                type="Book Your Trial, Now"
                buttonLocation={LEAD_GEN_HOME_PROJECTS}
              />
            </SaleMiddleStrip>
          </div>
        );

      default:
        return <></>;
    }
  };

  useEffect(() => {
    //webengage events specific to FSD Page(experiment):
    GTM.track(gtmEvents.PAGE_VIEW_FSD, {
      type: data.PrimaryProgramID,
      slug: data.slug,
    });

    //GA EVENT FOR PAGE VIEW:
    GTM.track(gtmEvents.PAGE_VIEW, {
      type: data.PrimaryProgramID,
      slug: data.slug,
    });
  }, []);

  return (
    <div>
      <SEO
        title={data.SEOTitle}
        description={data.SEODescription}
        canonicalUrl={data.canonicalUrl}
        meta={data.metatags || []}
      >
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </SEO>
      <ScrollButtonComponent
        component={
          <LeadGenerationButton
            type="Book Your Trial, Now"
            buttonLocation={LEAD_GEN_FLOATING_CTA}
          />
        }
        startAt={600}
      ></ScrollButtonComponent>
      <Navigation
        program={program.PrimaryProgramID}
        sale={sale}
        hideCTA
      ></Navigation>
      <div className="">
        <div className="text-v5-neutral-300">
          <FspStylePageHero
            program={program}
            title={data.heroTitle}
            image={data.heroImage.childImageSharp}
            description={data.heroDescription}
            subTitle={data.heroSubtitle}
            tags={data.heroTags}
            stats={
              [
                // {
                //   title: 'Next Batch',
                //   subtitle: format(
                //     new Date(program.ProgramDate),
                //     'MMMM dd, yyyy',
                //   ),
                // },
              ]
            }
            statsSubtitle={data.statsSubtitle}
            sale={sale}
            showOpenForm
          ></FspStylePageHero>
        </div>
        <CrackedCrioCareersSection
          postContent={
            <PostContentCTALayout>
              <div>
                {/* <div className="-mb-10">
                  <StatsPanelFSP
                    stats={placementStats.map((stat) => {
                      return {
                        title: stat.content,
                        subtitle: `${stat.label}`,
                      };
                    })}
                  ></StatsPanelFSP>
                </div>*/}
                <PostContentCTALayout className="mb-10">
                  <Link to={ERoutes.PLACEMENTS}>
                    <CrioButton
                      variant="secondary"
                      onClick={onPlacementButtonClick}
                      className="h-[64px] w-[300px] border-v5-neutral-600 py-6 text-v5-neutral-600 sm:w-auto"
                    >
                      Get our Placement Stats
                    </CrioButton>
                  </Link>
                  <LeadGenerationButton
                    type="Book Your Trial, Now"
                    className="h-[64px] w-[300px]"
                    buttonLocation={LEAD_GEN_DEVELOPERS_CRACKED}
                  />
                </PostContentCTALayout>
              </div>
            </PostContentCTALayout>
          }
          heading="Crio Graduates Work At"
        ></CrackedCrioCareersSection>

        <SkillSectionV2
          heading={data.skillsHeading}
          skills={data.skillsByCategory}
        />

        <ProgramHighlights
          heading={'What Makes This Program Different'}
          subtitle={
            ' Industry-grade projects, AI-native development, and a direct path to careers at top companies.'
          }
          programHighlights={data.programHighlights}
        />
        <WhyCrioSectionV3
          heading={data.highlightsTitle}
          description={data.highlightsDescription}
          quote={data.highlightsQuote}
          data={data.highlightsV2}
          postContent={
            <PostContentCTALayout>
              <LeadGenerationButton
                type="Book Your Trial, Now"
                buttonLocation={LEAD_GEN_WHY_CRIO}
              />
            </PostContentCTALayout>
          }
        ></WhyCrioSectionV3>

        <CrioComparisonSectionV2
          postContent={
            <div className="-mt-12">
              <PostContentCTALayout>
                <LeadGenerationButton
                  type="Book Your Trial, Now"
                  buttonLocation={LEAD_GEN_CRIO_COMPARISION}
                />
              </PostContentCTALayout>
            </div>
          }
        ></CrioComparisonSectionV2>

        <div className="min-h-[800px] py-10">
          <ProjectsV2
            heading={data.projectsTitle}
            description={data.projectsDescriptionV2}
            projects={data.projects}
            type="FSP"
            postContent={
              <PostContentCTALayout>
                <LeadGenerationButton
                  type="Book Your Trial, Now"
                  buttonLocation={LEAD_GEN_PROJECTS}
                />
              </PostContentCTALayout>
            }
            preContent={getProjectsSectionPreContent(sale)}
          ></ProjectsV2>
        </div>

        <ChooseSpecialization data={data.chooseSpecialization} />
        <CurriculumV5
          heading={''}
          description={''}
          quote={data.curriculumQuote}
          type={data.PrimaryProgramID}
          pageType="FSD"
          premiumCurriculumHeading={data.premiumCurriculumHeading}
          premiumCurriculumSubtitle={data.premiumCurriculumSubtitle}
          advancedAddOnsHeading={data.advancedAddOnsHeading}
          advancedAddOnsSubtitle={data.advancedAddOnsSubtitle}
          advancedAddOnsHighlight={data.advancedAddOnsHighlight}
          curriculum={curriculumData.curriculum}
          advancedCurriculum={curriculumData.advancedCurriculum}
          dreamCompanies={data.dreamCompanies}
          superDreamCompanies={data.superDreamCompanies}
          brochureViewHref={
            data.brochurePdf
              ? `${data.slug.replace(/\/$/, '')}/view-brochure/`
              : null
          }
        />

        <WhyCrioSectionV3
          heading={data.aiHighlightsTitle}
          description={data.aiHighlightsSubtitle}
          quote={data.highlightsQuote}
          data={data.aiHighlights}
        ></WhyCrioSectionV3>

        <ProgramHighlights
          heading={'Placement Outcomes'}
          subtitle={
            "Our graduates are landing roles at India's top tech companies"
          }
          programHighlights={data.placementHighlights}
        />

        <MentorTestimonialsSection />

        {data.technologies ? (
          <TechnologiesMasterSection
            data={data.technologies}
            postContent={
              <PostContentCTALayout>
                <LeadGenerationButton
                  type="Book Your Trial, Now"
                  buttonLocation={'LEAD_GEN_TECHNOLOGIES'}
                />
              </PostContentCTALayout>
            }
          />
        ) : (
          <></>
        )}

        {/* <WhyCrioSection
          heading={data.careerTitleV2}
          description={data.careerDescription}
          data={data.careers}
          postContent={
            <PostContentCTALayout>
              <LeadGenerationButton
                type="Book Your Trial, Now"
                buttonLocation={LEAD_GEN_CAREER_ASSISTANCE}
              />
            </PostContentCTALayout>
          }
        ></WhyCrioSection> */}

        <FspPricingCardSection
          price={data.price}
          duration={data.priceDuration}
          sale={sale}
          program={program.PrimaryProgramID}
          postContent={
            <PostContentCTALayout>
              <LeadGenerationButton
                type="Book Your Trial, Now"
                buttonLocation={LEAD_GEN_CURRICULUM_PRICING_CARD}
              />
            </PostContentCTALayout>
          }
        ></FspPricingCardSection>
        <VideoTestimonialSection
          quote={
            isDataSciencePage ? (
              <>
                Get more insights on how Crio can help you{' '}
                <br class="hidden sm:block" />
                crack a data analytics role in top tech companies.
              </>
            ) : (
              data.testimonialQuote
            )
          }
          disableCareerHandbook={
            data.PrimaryProgramID === EProgramIDs.QA_AUTOMATION_TESTING
          }
          postContent={
            <PostContentCTALayout>
              <div className="-mt-16 xxs:-mt-10 sm:-mt-0">
                <LeadGenerationButton
                  type="Book Your Trial, Now"
                  buttonLocation={LEAD_GEN_TESTIMONIALS}
                />
              </div>
            </PostContentCTALayout>
          }
        ></VideoTestimonialSection>
      </div>

      <FAQSection data={data.faqs}></FAQSection>
      <FooterV2></FooterV2>
      <BottomStrip />
    </div>
  );
}

export const pageQuery = graphql`
  query ($id: String!) {
    fspStylePagesYaml(id: { eq: $id }) {
      PrimaryProgramID
      slug
      SEOTitle
      canonicalUrl
      SEODescription

      metatags {
        property
        content
      }

      heroTitle
      heroSubtitle
      heroDescription
      heroTags
      heroImage {
        childImageSharp {
          gatsbyImageData(
            width: 750
            quality: 100
            blurredOptions: {}
            placeholder: NONE
            formats: [AUTO, WEBP]
          )
        }
      }

      statsSubtitle

      highlights {
        description
        image {
          childImageSharp {
            gatsbyImageData(
              width: 200
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }

      highlightsV2 {
        description
        image {
          childImageSharp {
            gatsbyImageData(
              width: 200
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }

      programHighlights {
        image {
          childImageSharp {
            gatsbyImageData(
              width: 60
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
        title
        subtitle
      }

      aiHighlightsTitle
      aiHighlightsSubtitle
      aiHighlights {
        description
        tags
      }

      placementHighlights {
        image {
          childImageSharp {
            gatsbyImageData(
              width: 60
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
        title
        subtitle
      }

      projectsTitle
      projectsDescription
      projectsDescriptionV2
      projects {
        title
        subtitle
        tags
        skills
        points
      }

      chooseSpecialization {
        badge
        title
        description
        footerNote
        cards {
          badge
          title
          description
          tech
          projects {
            name
            description
          }
          advancedTitle
          advancedContent
        }
      }

      careerTitle
      careerTitleV2
      careerDescription
      careers {
        description
        image {
          childImageSharp {
            gatsbyImageData(
              width: 200
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }

      curriculumTitle
      curriculumDescription
      curriculumQuote
      premiumCurriculumHeading
      premiumCurriculumSubtitle
      advancedAddOnsHeading
      advancedAddOnsSubtitle
      advancedAddOnsHighlight

      technologies {
        name
        image {
          childImageSharp {
            gatsbyImageData(
              width: 200
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }

      skillsHeading

      skillsByCategory {
        frontend {
          title
          skills {
            name
            originalImage {
              childImageSharp {
                gatsbyImageData(
                  width: 300
                  quality: 100
                  blurredOptions: {}
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
        backend {
          title
          skills {
            name
            originalImage {
              childImageSharp {
                gatsbyImageData(
                  width: 300
                  quality: 100
                  blurredOptions: {}
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
        ai_development {
          title
          skills {
            name
            originalImage {
              childImageSharp {
                gatsbyImageData(
                  width: 300
                  quality: 100
                  blurredOptions: {}
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
        ai_infastructure {
          title
          skills {
            name
            originalImage {
              childImageSharp {
                gatsbyImageData(
                  width: 300
                  quality: 100
                  blurredOptions: {}
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
      }

      dreamCompanies {
        image {
          childImageSharp {
            gatsbyImageData(
              width: 300
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
        originalImage {
          childImageSharp {
            gatsbyImageData(
              width: 300
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
      superDreamCompanies {
        image {
          childImageSharp {
            gatsbyImageData(
              width: 300
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
        originalImage {
          childImageSharp {
            gatsbyImageData(
              width: 300
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
      curriculum {
        title
        image {
          childImageSharp {
            gatsbyImageData(
              width: 100
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
        duration
        tag
        data
        skills
        anchor
        cardTitle
        cards {
          image {
            childImageSharp {
              gatsbyImageData(
                width: 300
                quality: 100
                blurredOptions: {}
                placeholder: BLURRED
                formats: [AUTO, WEBP]
              )
            }
          }
          data
          skills
          title
        }
      }

      curriculumfsd {
        basicCurriculumFSD {
          description
          duration
          title
          cards {
            description
            skills
            title
            subCards {
              description
              title
              skills
              spanToWidth
            }
          }
          image {
            childImageSharp {
              gatsbyImageData(
                width: 100
                quality: 100
                blurredOptions: {}
                placeholder: BLURRED
                formats: [AUTO, WEBP]
              )
            }
          }
          subCards {
            description
            skills
            spanToWidth
            title
          }
          specializationType {
            numberOfCards
            title
          }
          description1
          description2
          skills
        }
        advancedCurriculumFSD {
          duration
          cards {
            description
            subCards {
              description
              skills
              spanToWidth
              title
              isCardLarge
            }
            title
            skills
          }
          image {
            childImageSharp {
              gatsbyImageData(
                width: 100
                quality: 100
                blurredOptions: {}
                placeholder: BLURRED
                formats: [AUTO, WEBP]
              )
            }
          }
          title
          description
        }
        aspiringDeveloper {
          description
          duration
          title
          cards {
            description
            skills
            title
            subCards {
              description
              title
              skills
              spanToWidth
            }
          }
          image {
            childImageSharp {
              gatsbyImageData(
                width: 100
                quality: 100
                blurredOptions: {}
                placeholder: BLURRED
                formats: [AUTO, WEBP]
              )
            }
          }
          subCards {
            description
            skills
            spanToWidth
            title
          }
          specializationType {
            numberOfCards
            title
          }
          description1
          description2
          skills
        }
        aspiringSeniorDeveloper {
          duration
          cards {
            description
            subCards {
              description
              skills
              spanToWidth
              title
              isCardLarge
            }
            title
            skills
          }
          image {
            childImageSharp {
              gatsbyImageData(
                width: 100
                quality: 100
                blurredOptions: {}
                placeholder: BLURRED
                formats: [AUTO, WEBP]
              )
            }
          }
          title
          description
        }
      }

      advancedCurriculum {
        title
        image {
          childImageSharp {
            gatsbyImageData(
              width: 100
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
        duration
        tag
        data
        skills
        cardTitle
        cards {
          image {
            childImageSharp {
              gatsbyImageData(
                width: 300
                quality: 100
                blurredOptions: {}
                placeholder: BLURRED
                formats: [AUTO, WEBP]
              )
            }
          }
          data
          skills
          title
        }
      }

      steps

      price
      priceDuration

      faqs {
        question
        answer
      }

      jobGuarantee {
        question
        answer
        image {
          childImageSharp {
            gatsbyImageData(
              width: 300
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }

      brochureProgramName
      brochurePdf
      brochureBookmarks {
        label
        page
      }
    }

    allStrapiPrograms {
      ...allStrapiProgramsFragment
    }

    ...strapiDataFragment
  }
`;
